import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = ({
  newAmbassadorStyle,
}: { newAmbassadorStyle?: boolean } = {}) =>
  makeStyles(({ breakpoints }: Theme) => ({
    fieldset: {
      border: 'none',
      padding: 0,
      margin: 0,
    },
    heading: {
      marginBottom: 20,
      marginTop: 30,
    },
    formScreen: {
      outline: 'none',
      marginTop: 30,
      ...(newAmbassadorStyle && {
        [breakpoints.down(1024)]: {
          marginTop: 10,
        },
      }),
    },
    footer: {
      display: 'flex',
      width: '100%',
      justifyContent: 'space-between',
      [breakpoints.down(newAmbassadorStyle ? 1024 : 'sm')]: {
        flexDirection: 'column-reverse',
        '&>*:not(:first-child)': {
          marginBottom: 30,
        },
      },
    },
  }));
